import type { FaireProductEntity } from "../../entity_types/product";

export const p_m7eysvyg9v: FaireProductEntity = {
  token: "p_m7eysvyg9v",
  type: "product",
  name: "Moroccan Kilim Open-Toe Slides",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/d3b563a9d05ebbfee5922b4c6443a3c9d3affb1adc5a5b776c2d29623d8a0d76.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bb308f74b33a5015abc6af4fa2a9b8fba30d85b35477cab725f6c3c08c6bc498.jpeg",
    "https://cdn.faire.com/fastly/29244ccf90d21ecf3a24a3ec0d8b8ff3ac284018339ea5f2ea2a633008ec6c93.jpeg",
    "https://cdn.faire.com/fastly/433946130127f2adeef88d65a28cca1a6c160247e70a6b784cc095eec3a84375.jpeg",
    "https://cdn.faire.com/fastly/451181cca2c727cc68a51181eac592799faa6f1a7ba3e88a87f8a777140624b6.jpeg",
    "https://cdn.faire.com/fastly/252e968ffcb6f09275e7a9825a6a59708dbe4b5c415a452eb0117a0844288e9a.jpeg",
    "https://cdn.faire.com/fastly/5e002ce6f68b7be651008f68fd3d8f6385456476953b3f4506b23c53ffdfff6d.jpeg",
    "https://cdn.faire.com/fastly/6ec453e0d3e59d3864a0e6117ac1bacf738ea056624f605e290c1bc02975f35f.jpeg",
    "https://cdn.faire.com/fastly/7ed0922a6b2ff243759584a4ae8f535978c2fdb29dd3159493a6ba15c01a63b4.jpeg",
    "https://cdn.faire.com/fastly/38dd582890a378017d5d5dea4b87a0905ee526eeab29e3b1a8cdb657ec65e3b0.jpeg",
  ],
  priceDollars: 30,
  description:
    "Step into style with a touch of Moroccan heritage. Handcrafted from authentic vintage kilim rugs, these open-toe slides combine unique, one-of-a-kind patterns with supple leather for ultimate comfort. Featuring a durable rubber sole, they’re designed for both indoor lounging and outdoor strolls. Versatile and unique, these slides look effortlessly chic with a simple pair of jeans or your favorite warm weather outfit. \n\nEach pair tells its own story, blending traditional craftsmanship with everyday wearability. Moroccan textile Kilim rugs are among the most vivid in all the world. The wool is dyed with natural dyes, resulting in extremely varied designs and colors. Our slides are made of these vintage rugs, so each pair has a deep sense of history. Like snowflakes, no two pairs of our Kilim Slides are alike. Each pair will be varied in color and pattern.\n\nAvailable in whole sizes 6, 7, 8, 9, 10.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:55.988Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
